<!--设备管理-->
<template>
  <div class="equip-container">
    <!-- 查询栏 -->
    <div class="query-nav">
      <el-form ref="queryFormRef" :model="queryForm" label-width="70px">
        <el-row :gutter="8" type="flex" justify="space-between">
          <el-col :span="4">
            <el-form-item prop="orgId" label="所属机构">
              <el-select filterable v-model="queryForm.orgId" placeholder="请输入/选择">
                <el-option
                  v-for="item in orgList"
                  :key="item.orgId"
                  :label="item.orgName"
                  :value="item.orgId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item prop="searchValue" label="关键字">
              <el-input
                v-model.trim="queryForm.searchValue"
                placeholder="请输入编号/名称/品牌/型号/系列"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item prop="status" label="设备状态">
              <el-select v-model="queryForm.status" placeholder="请选择" style="width: 100%">
                <el-option label="可用" value="0"></el-option>
                <el-option label="不可用" value="1"></el-option>
                <el-option label="废弃" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="创建日期">
              <el-date-picker
                v-model="dateTime"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                @change="dateTimeChange"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-button type="primary" style="margin-right: 6px" @click="handleSearch"
              >搜索</el-button
            >
            <el-button @click="handleReset">重置</el-button>
          </el-col>
          <el-col :span="2">
            <el-button type="primary" style="float: right" @click="handleAddNewDevice"
              >点击新增</el-button
            >
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-button type="danger" style="margin-bottom: 22px" @click="handleDelList"
              >点击删除</el-button
            >
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- 表格区域 -->
    <div class="table">
      <el-table
        :data="equipmentList"
        v-loading="tableLoading"
        @selection-change="handleSelectionChange"
        stripe
        border
      >
        <el-table-column
          width="40"
          align="center"
          fixed
          type="selection"
          :resizable="false"
        ></el-table-column>
        <el-table-column
          width="60"
          fixed
          type="index"
          label="序号"
          align="center"
          :resizable="false"
        ></el-table-column>
        <el-table-column
          width="200"
          fixed
          prop="orgName"
          label="所属机构"
          show-overflow-tooltip
          align="center"
          :resizable="false"
        ></el-table-column>
        <el-table-column
          width="200"
          prop="uniqueNumber"
          label="系统唯一标识"
          align="center"
          :resizable="false"
        ></el-table-column>
        <el-table-column
          width="200"
          prop="deviceName"
          label="设备名称"
          align="center"
          :resizable="false"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          width="200"
          prop="deviceCategoryName"
          label="设备类型"
          align="center"
          :resizable="false"
        ></el-table-column>
        <el-table-column
          width="200"
          prop="deviceTypeName"
          label="设备品牌"
          align="center"
          :resizable="false"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          width="200"
          prop="deviceSeriesName"
          label="设备系列"
          align="center"
          :resizable="false"
          show-overflow-tooltip
        >
          <template slot-scope="{ row }">
            {{ row.deviceSeriesName || '-' }}
          </template>
        </el-table-column>
        <el-table-column
          width="200"
          prop="deviceModel"
          label="设备型号"
          align="center"
          :resizable="false"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          width="200"
          prop="factoryNo"
          label="出厂编号"
          align="center"
          :resizable="false"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="200"
          prop="deviceIp"
          label="设备IP"
          align="center"
          :resizable="false"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="200"
          prop="lng"
          label="经度"
          align="center"
          :resizable="false"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="200"
          prop="lat"
          label="纬度"
          align="center"
          :resizable="false"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="200"
          prop="region"
          label="所属区域"
          align="center"
          :resizable="false"
        ></el-table-column>
        <el-table-column
          width="200"
          prop="createTime"
          label="创建时间"
          align="center"
          :resizable="false"
        ></el-table-column>
        <el-table-column
          width="200"
          prop="updateTime"
          label="更新时间"
          align="center"
          :resizable="false"
        ></el-table-column>
        <el-table-column width="200" prop="status" label="状态" align="center" :resizable="false">
          <template slot-scope="{ row }">
            <span>{{ row.status == 0 ? '可用' : row.status == 1 ? '不可用' : '废弃' }}</span>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          width="200"
          prop="mn"
          label="MN"
          align="center"
          :resizable="false"
        ></el-table-column>
        <el-table-column fixed="right" label="操作" align="center" :resizable="false">
          <template slot-scope="{ row }">
            <el-tooltip class="item" effect="dark" content="查看" placement="top">
              <i class="iconfont iconcaozuo-8chakanxiangqing_1" @click="handleEdit(row)"></i>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="删除" placement="top">
              <i class="iconfont iconcaozuo-2shanchu_1" @click="handleDel(row)"></i>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页区域 -->
    <div class="page">
      <el-pagination
        :total="total"
        :current-page="queryForm.pageNo"
        :page-size="queryForm.pageSize"
        :page-sizes="[10, 20, 30, 50]"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>

    <!-- 新增/编辑设备组件 -->
    <AddOrEditDevice
      ref="addOrEdit"
      :org-list="orgList"
      :areaList="areaList"
      @back="handleCloseDeviceComponent"
    />
    <!-- 删除组件 -->
    <DelDevice @back="handleDelBack" ref="delDevice" />
  </div>
</template>

<script>
import { chunk } from 'lodash';
import AddOrEditDevice from './device-components/AddOrEditDevice';
import DelDevice from './device-components/DelDevice';
// import { flatMaps } from '@/utils/areaFlatMap';
import deviceApi from 'api/home/device.js';
import newDeviceApi from 'api/home/device-mangement';
export default {
  components: { AddOrEditDevice, DelDevice },
  data() {
    return {
      total: 0,
      dateTime: '',
      orgList: [],
      areaList: [],
      delDeviceList: [],
      queryForm: {
        pageNo: 1,
        pageSize: 10,
        orgId: '',
        searchValue: '',
        // deviceCategoryId: '',
        // deviceTypeName: '',
        status: '',
        searchBeginTime: '',
        searchEndTime: ''
      },
      tableLoading: true,
      equipmentList: [],
      deviceDialogTitle: '',
      deviceDialogVisible: false,
      currentDeviceId: ''
    };
  },
  created() {
    this.getOrgListData();
    this.getEquipmentListData();
    this.getAreaList();
  },
  methods: {
    // 获取机构下拉列表数据
    getOrgListData() {
      deviceApi.getOrgList().then(res => {
        if (res.data.code === 200) {
          this.orgList = res.data.data;
        }
        // else {
        //   this.$message.error(res.data.message);
        // }
      });
    },

    // 获取划区树
    getAreaList() {
      newDeviceApi.getGbCityList().then(res => {
        const {
          data: { code, data }
        } = res;
        if (code !== 200) {
          return;
        }
        // console.log(flatMaps(data));

        this.areaList = this.areaTreeToOption(data);
      });
    },

    areaTreeToOption(data) {
      return data.map(item => {
        let arr = {
          label: item.title,
          value: item.value
        };
        if (item.children && item.children.length) {
          arr.children = this.areaTreeToOption(item.children);
        }
        return arr;
      });
    },
    // 日期选择
    dateTimeChange(val) {
      if (val) {
        this.queryForm.searchBeginTime = val[0];
        this.queryForm.searchEndTime = val[1];
      } else {
        this.queryForm.searchBeginTime = '';
        this.queryForm.searchEndTime = '';
      }
    },
    // 搜索
    handleSearch() {
      this.queryForm.pageNo = 1;
      this.getEquipmentListData();
    },
    // 重置
    handleReset() {
      this.$refs.queryFormRef.resetFields();
      this.dateTime = '';
      this.queryForm.searchBeginTime = '';
      this.queryForm.searchEndTime = '';
      this.queryForm.pageNo = 1;
      this.queryForm.pageSize = 10;
      this.queryForm.searchValue = '';
      this.getEquipmentListData();
    },
    // 获取设备列表数据
    getEquipmentListData() {
      this.tableLoading = true;
      newDeviceApi
        .getDeviceList(this.queryForm)
        .then(res => {
          if (res.data.code === 200) {
            this.total = res.data.data.totalRows;
            this.equipmentList = res.data.data.rows;
          }
          this.tableLoading = false;

          // else {
          //   this.$message.error(res.data.message);
          //   this.tableLoading = false;
          // }
        })
        .catch(err => {
          this.tableLoading = false;
        });
    },
    // 分页
    handleSizeChange(val) {
      this.queryForm.pageNo = 1;
      this.queryForm.pageSize = val;
      this.getEquipmentListData();
    },
    handleCurrentChange(val) {
      this.queryForm.pageNo = val;
      this.getEquipmentListData();
    },

    // 点击新增
    handleAddNewDevice() {
      this.$refs.addOrEdit.init();
    },
    // 点击编辑
    handleEdit(row) {
      this.$refs.addOrEdit.init(row.id, true);
    },
    // 复选事件
    handleSelectionChange(val) {
      this.delDeviceList = val.map(item => {
        return item.id;
      });
    },
    // 删除一组设备
    handleDelList() {
      if (!this.delDeviceList.length) {
        this.$message.error('至少选中一个设备');
        return;
      }
      this.$refs.delDevice.init(this.delDeviceList);
    },
    // 点击删除
    handleDel(row) {
      this.$refs.delDevice.init([row.id]);
    },
    // 删除返回
    handleDelBack() {
      this.getEquipmentListData();
    },
    // 组件点击取消
    handleCloseDeviceComponent(data) {
      // console.log(data);
      // 新增或编辑成功 200为新增， 233为编辑 ，新增成功重置查询参数，编辑成功无需重置
      if (data === 200) {
        this.handleReset();
      } else if (data === 233) {
        this.getEquipmentListData();
      }
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .el-date-editor--daterange.el-input,
.el-date-editor--daterange.el-input__inner,
.el-date-editor--timerange.el-input,
.el-date-editor--timerange.el-input__inner {
  width: 100%;
}
/deep/ .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}

/deep/ .el-table__empty-block {
  text-align: left;
}

/deep/ .el-table .cell {
  white-space: pre;
}

.equip-container {
  padding: 16px;

  .page {
    margin: 16px 0;
    float: right;
  }
}

.iconfont {
  font-size: 28px;
  color: #409dff;
  cursor: pointer;
}
.iconcaozuo-2shanchu_1 {
  color: #fc4c2f;
}
</style>
